import { Box } from '@mui/material'
import { LineChart, type LineData, type XAxisPeriod } from 'ComponentLibrary'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import type { LineChartTooltipCopy, LineChartTooltipTranslations } from 'ComponentLibrary/src/molecules/Chart/LineChartTooltip'

export type MoneyChartProps = {
    series: LineData[]
    title: string
    period: XAxisPeriod
    currencySymbol: string
    showChange?: boolean
    yearOnly?: boolean
    yearFilterUnitLabel?: string
    trimLeadingZeroes?: boolean
    emptyStateTitle?: string
    lineChartTooltipCopy?: Partial<LineChartTooltipCopy>
    calendarWeekLabel?: string
    tooltipTranslations?: LineChartTooltipTranslations
    locale?: string
}

export function MoneyChart({
    series,
    title,
    currencySymbol,
    period = 'year',
    showChange = false,
    yearOnly = false,
    yearFilterUnitLabel,
    trimLeadingZeroes = false,
    emptyStateTitle,
    lineChartTooltipCopy,
    calendarWeekLabel,
    tooltipTranslations,
    locale,
}: MoneyChartProps) {
    const mappedData = series.map((serie) => ({
        ...serie,
        data: serie.data.map(({ value, date, ...rest }) => ({
            value: value !== undefined ? value / 100 : undefined, // cents to euros Change this to proper formatting eventually
            date,
            ...rest,
        })),
    }))

    return (
        <Box height="100%">
            <Headline variant="headline3" title={title} />
            <LineChart
                data={mappedData}
                yUnit={currencySymbol}
                period={period}
                showTrends={showChange}
                startAtZero={true}
                yearOnly={yearOnly}
                withYearFilter
                yearFilterUnitLabel={yearFilterUnitLabel}
                trimLeadingZeroes={trimLeadingZeroes}
                emptyStateTitle={emptyStateTitle}
                lineChartTooltipCopy={lineChartTooltipCopy}
                calendarWeekLabel={calendarWeekLabel}
                tooltipTranslations={tooltipTranslations}
                locale={locale}
            />
        </Box>
    )
}
